// extracted by mini-css-extract-plugin
export default {"card":"NumberCard__card--3F2","cardNumber":"NumberCard__cardNumber--39C"};